module.exports = __webpack_public_path__ + "static/curious-28397f95e1f720902046f244d6bbae2c.png";